/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.DocumentProperties";
        class ComponentDocProperties extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = null;
                // UI Components
                this._loader = null;
                this._noProperties = null;
                this._propsContainer = null;
                // Data state
                this._currentDocId = null;
                this._currentDocument = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("DocPropertiesComponent._storeHtml()");
                    ComponentDocProperties.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this.showPropsForDocument = (doc) => {
                    this._log.info("DocPropertiesComponent.showPropsForDocument()");
                    this._currentDocument = doc;
                    this._currentDocId = doc.ItemNum;
                    if (!this._componentReady) {
                        this._displayPending = 'object';
                        return;
                    }
                    else {
                        this._displayProps();
                    }
                };
                this.showPropsForDocumentId = (doc) => {
                    this._log.info("DocPropertiesComponent.showPropsForDocumentId()");
                    this._currentDocument = null;
                    this._currentDocId = doc;
                    if (!this._componentReady) {
                        this._displayPending = 'service';
                        return;
                    }
                    else {
                        this._loadProps();
                    }
                };
                this._loadProps = () => {
                    this._log.info("DocPropertiesComponent._loadProps()");
                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetDocument/${this._currentDocId}`, this._receiveProps, this._errorCallback, this._failCallback);
                };
                this._receiveProps = (response) => {
                    this._log.info("DocPropertiesComponent._receiveProps()");
                    if (response.hasOwnProperty('Documents') && response.Documents && response.Documents.length > 0) {
                        this._currentDocument = response.Documents[0];
                    }
                    else {
                        this._currentDocument = null;
                    }
                    this._displayProps();
                };
                this._displayProps = () => {
                    this._log.info("DocPropertiesComponent._displayProps()");
                    if (!this._currentDocument) {
                        this._core.Functions.showElement(this._noProperties);
                        return;
                    }
                    this._propsContainer.innerHTML = "";
                    this._core.Functions.hideElement(this._noProperties);
                    this._core.Functions.showElement(this._propsContainer);
                    // Do the job
                    let doc = this._currentDocument;
                    let fragment = document.createDocumentFragment();
                    let rootPropValue = this._addPropertyRow(fragment, this._core.Locale.getTranslation('STR_WPT_DOC_PROPERTIES'), null, true);
                    if (this._config.Handle)
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_DOCHANDLE'), doc.ItemNum.toString());
                    // This should probably be the real name?
                    if (this._config.DocType)
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_DOCTYPE'), doc.DocType.Name);
                    if (this._config.FileFormat)
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_FILE_FORMAT'), doc.FileType);
                    if (this._config.DocDate && doc.Date) {
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_DOCDATE'), this._core.OBHelper.formatDate(doc.Date));
                    }
                    if (this._config.CreatedBy && doc.CreatedBy)
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_CREATED_BY'), doc.CreatedBy);
                    if (this._config.Revisionable) {
                        let allow = (doc.AllowRevisions) ? this._core.Locale.getTranslation('STR_WPT_YES') : this._core.Locale.getTranslation('STR_WPT_NO');
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_IS_REVISIONABLE'), allow);
                    }
                    if (this._config.Revision)
                        this._addPropertyRow(rootPropValue, this._core.Locale.getTranslation('STR_WPT_REVISION_LEVEL'), doc.RevisionCount.toString());
                    this._propsContainer.appendChild(fragment);
                };
                this._addPropertyRow = (parent, propName, propValue, omitColon = false) => {
                    this._log.info("DocPropertiesComponent._addPropertyRow()");
                    let colon = omitColon ? '' : ':';
                    let propDiv = document.createElement('div');
                    parent.appendChild(propDiv);
                    propDiv.classList.add('property-row');
                    let nameSpan = document.createElement('span');
                    nameSpan.classList.add('property-name');
                    nameSpan.appendChild(document.createTextNode(propName + colon));
                    propDiv.appendChild(nameSpan);
                    let valSpan = document.createElement('span');
                    valSpan.classList.add('property-value');
                    if (propValue !== null && propValue !== undefined) {
                        valSpan.appendChild(document.createTextNode(propValue));
                    }
                    propDiv.appendChild(valSpan);
                    return valSpan;
                };
                this.clearDisplay = () => {
                    this._log.info("DocPropertiesComponent.clearDisplay()");
                    this._currentDocId = null;
                    this._currentDocument = null;
                    this._propsContainer.innerHTML = "";
                    this._core.Functions.showElement(this._noProperties);
                    this._core.Functions.hideElement(this._propsContainer);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocPropertiesComponent::constructor");
                // Configuration moved from base class so we can type it correctly
                if (config) {
                    this._config = config;
                    if (!this._config.hasOwnProperty('Handle') || (this._config.Handle == null))
                        this._config.Handle = true;
                    if (!this._config.hasOwnProperty('DocType') || (this._config.DocType == null))
                        this._config.DocType = true;
                    if (!this._config.hasOwnProperty('FileFormat') || (this._config.FileFormat == null))
                        this._config.FileFormat = true;
                    if (!this._config.hasOwnProperty('DocDate') || (this._config.DocDate == null))
                        this._config.DocDate = true;
                    if (!this._config.hasOwnProperty('CreatedBy') || (this._config.CreatedBy == null))
                        this._config.CreatedBy = true;
                    if (!this._config.hasOwnProperty('Revisionable') || (this._config.Revisionable == null))
                        this._config.Revisionable = true;
                    if (!this._config.hasOwnProperty('Revision') || (this._config.Revision == null))
                        this._config.Revision = true;
                }
                else
                    this._config = { Handle: true, DocType: true, FileFormat: true, DocDate: true, CreatedBy: true, Revisionable: true, Revision: true };
                // But the html is static
                if (!ComponentDocProperties.Html) {
                    core.Loader.getVersionedHTML('widgets/components/docprops.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("DocPropertiesComponent._present()");
                this._container.innerHTML = ComponentDocProperties.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noProperties = this._container.querySelector('#docPropsComponentNoProps');
                this._propsContainer = this._container.querySelector('#docPropsInfoContainer');
                this._core.Helper.prepareHourglassIcon(this._loader);
                this._core.Helper.setElementTranslation(this._container.querySelector('#docPropsComponentLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#docPropsComponentNoPropsLabel'), 'STR_WPT_NO_PROPS_AVAILABLE');
                this._componentReady = true;
                if (this._displayPending == 'service')
                    this._loadProps();
                else if (this._displayPending == 'object')
                    this._displayProps();
                this._displayPending = "";
            }
        }
        ComponentDocProperties.Html = null;
        Widgets.ComponentDocProperties = ComponentDocProperties;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
